
<style lang="scss">
.input-field {
  width: 100%;
}
.ql-editor.ql-blank {
  min-height: 150px;
}
.track-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 9px;
}
.track-select {
  width: 85%;
  margin-right: 15px;
}
.input-track-name {
  width: 75%;
  margin-right: 15px;
}
.add-track-inner-section {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.rqrd {
  color: #f00;
}
</style>
<template>
  <div id="user-edit-tab-info">
    <!-- Content Row -->
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full mt-4">
        <label>
          Category Name
          <span class="rqrd">*</span>
        </label>
        <vs-input
          class="w-full mt-3"
          name="Category Name"
          v-model="data_local[0].CatName"
          v-validate="'required'"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('Category Name')"
        >{{ errors.first('Category Name') }}</span>
      </div>
      <div class="vx-col md:w-1/2 w-full mt-4">
        <!-- <label>
          Seats
          <span class="rqrd">*</span>
        </label>
        <vs-input
          class="w-full mt-3"
          type="number"
          name="Capacity"
          value="6"
          readonly
          v-model="data_local.Capacity"
          v-validate="'required'"
        />
        <span
          class="text-danger text-sm"
          v-show="errors.has('Capacity')"
        >{{ errors.first('Capacity') }}</span>-->
      </div>
    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
            class="ml-auto mt-2"
            @click="before_save"
            :disabled="!validateForm"
          >Save Changes</vs-button>
        </div>
      </div>
    </div>
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
  </div>
</template>

<script>
import vSelect from "vue-select";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";

// import moduleAttendeeManagement from "@/store/attendee-management/moduleAttendeeManagement.js";
// import moduleExhibitorManagement from "@/store/exhibitor-management/moduleExhibitorManagement.js";
// import moduleSponsorManagement from "@/store/sponsor-management/moduleSponsorManagement.js";
// import moduleroundtableManagement from "@/store/roundtable-management/moduleRoundtableManagement.js";
import ls from "@/common/localStorage";
import con from "@/firebase/firebaseInit.ts";
var vm;
export default {
  components: {
    vSelect,
    quillEditor,
    "v-select": vSelect,
  },
  /*props: {
    data: {
      type: Object,
      required: true,
    },
  },*/
  data() {
    return {
      data_local: [{
        CatID: 0,
        CatName: "",
      }], // JSON.parse(JSON.stringify(this.data)),
      tableId: "",
      tableName: "",
      TopicName: null,
      popupActive: false,
      TopicList: [],

      Host: [],

      attendessList: [],

      mappedEntityList: [],

      content: " ",
      catID: null,
      TagsData: [],
    };
  },
  mounted() {
    debugger;
    this.catID = this.$route.params.CatID;
    console.log(this.catID);

    if (this.catID <= 0) {
      this.TagsData.push({
        CatID: 0,
        CatName: "",
      });
    } else {
      var cn = ls.getSessionEventCollectionName(); ///OA_UAT/BoothDesigns/Templates/2A1wtx9POQHMNWUlJ0PF
      var cref2 = con.eventDB
        .collection("OA_UAT")
        .doc("TagCategories")
        .collection("CategoryList")
        .where("CatID", "==", this.catID);

      cref2.get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          this.TagsData.push({
            CatID: doc.data().CatID,
            CatName: doc.data().CatName,
          });
        });

        this.data_local = this.TagsData;
        console.log(this.data_local[0].CatName);
      });
    }
  },
  computed: {    
    validateForm() {
      return !this.errors.any();
    },
  },
  methods: {
    getAutoId() {
      let AutoId = 0;
      console.log(con.instanceDB);
      let promise = new Promise((resolve, reject) => {
        con.instanceDB
          .doc("AutoID")
          .get()
          .then(function (doc) {
            if (!doc.exists) {
              con.instanceDB.doc("AutoID").set({ UserId: 0 });
              resolve(1);
            } else {
              con.instanceDB
                .doc("AutoID")
                .update({
                  UserId: firebase.firestore.FieldValue.increment(1),
                })
                .then(function () {
                  con.instanceDB
                    .doc("AutoID")
                    .get()
                    .then(function (doc) {
                      resolve(doc.data().UserId);
                    });
                });
            }
          });
      });

      // AutoId = await promise;
      AutoId = AutoId * 1000;
      return AutoId.toString();
    },
    before_save() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // if form have no errors
          this.save_changes();
        }
      });
    },
    save_changes() {
      /* eslint-disable */
      if (!this.validateForm) return;

      // Here will go your API call for updating data
      // You can get data in "this.data_local"

      /* eslint-enable */
        this.$vs.loading();
      //debugger;
      const Id = this.$route.params.CatID;
      var nm = this.data_local[0].CatName;

      let AutoID = "CT" + new Date().getTime();
      // let AutoID = context.dispatch('getAutoId');

      if (Id) {
        debugger;
        const promises = [];
        var cn = ls.getSessionEventCollectionName();
        var cref2 = con.eventDB
          .collection("OA_UAT")
          .doc("TagCategories")
          .collection("CategoryList")
          .where("CatID", "==", this.catID);

        cref2
          .get()
          .then((snap) => {
            snap.forEach((doc) => {
              promises.push(
                doc.ref.update({
                  CatName: this.data_local[0].CatName,
                })
              );
              return Promise.all(promises);
            });
          })
          .then((res) => {
            debugger;

            //alert(res.message)
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Tags Categpry",
              text: "Updated Successfully!",
            });
            this.$vs.loading.close();
          })
          .catch((err) => {
            //console.error(err)
            this.$vs.loading.close();
          });
      } else {
        let docObj = {
          CatID: null,
          CatName: this.data_local[0].CatName,
        };
        debugger;
        //  let AutoID = this.getAutoId();
        docObj.CatID = AutoID;
        debugger;
        const promises = [];
        var cn = ls.getSessionEventCollectionName();
        var cref2 = con.eventDB
          .collection("OA_UAT")
          .doc("TagCategories")
          .collection("CategoryList");
        //.where("CatID", "==", this.catID);

        cref2
          .doc(`${AutoID}`)
          .set(docObj)
          .then((res) => {
            debugger;

            //alert(res.message)
            this.$vs.notify({
              color: "success",
              position: "top-center",
              title: "Tags Categpry",
              text: "created Successfully!",
            });
            this.$vs.loading.close();
            this.$router.push("/tagscategpryins");
          })
          .catch(function (error) {
            // this.$vs.loading.close();
            reject(error);
          });

      }
    },

  },
  created() {
    vm = this;    
  }
};
</script>
